import { mapState } from 'vuex'
import Weather from '@/utils/Weather'

export default {
  name: 'ContentsWeatherAreaCode',
  data () {
    return {
      // 選択した都道府県
      inpPrefecture: '',

      // input
      input: ''
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      values: state => state.serviceContentsSettingForm.values,
    }),

    disableRegionSelector () {
      return this.inpPrefecture === ''
    },

    // list
    prefectureList () {
      return Weather.localWeather.point.map(item => {
        return {
          value: item.prefecture,
          label: item.prefecture
        }
      })
    },
    regionList () {
      if (this.inpPrefecture === '') return []

      const regions = Weather.localWeather.point.filter(item => item.prefecture === this.inpPrefecture)[0].list
      let list = []
      Object.keys(regions).forEach(key => list.push({
        value: key,
        label: regions[key]
      }))
      return list
    },

    // jsonb
    getJsonb () {
      return this.input
    },
  },
  watch: {
    inpPrefecture (to, from) {
      if (from === '') return
      this.input = ''
    }
  },
  methods: {
    init () {
      if (this.values.contentsWeatherAreaCode) {
        try {
          this.inpPrefecture = Weather.localWeather.point.filter(item => typeof item.list[this.values.contentsWeatherAreaCode] === 'string')[0].prefecture
          this.input = this.values.contentsWeatherAreaCode
        } catch (e) {
          this.input = ''
        }
      }
    },
  }
}
